import { render, staticRenderFns } from "./set08.vue?vue&type=template&id=f4344782&scoped=true&"
import script from "./set08.vue?vue&type=script&lang=js&"
export * from "./set08.vue?vue&type=script&lang=js&"
import style0 from "./set08.vue?vue&type=style&index=0&id=f4344782&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4344782",
  null
  
)

export default component.exports